<div class="goods-container">
  <div class="goods-topbar">
    <div class="topbar-left">
      <h1>
        Goods Received
        <small>Record incoming stock from suppliers</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Inventory</span> / <span class="current">Goods Received</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search receipts..." [ngModel]="search()" (ngModelChange)="search.set($event); onSearchChange()" />
      </div>
      <button class="btn btn-outline btn-sm" type="button" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" type="button" (click)="openReceiptModal()">
        <i class="bi bi-plus-circle"></i> New Receipt
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-receipt"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Receipts</div>
        <div class="stat-value">{{ stats().total }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Completed</div>
        <div class="stat-value">{{ stats().posted }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Draft</div>
        <div class="stat-value">{{ stats().draft }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-exclamation-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Returned</div>
        <div class="stat-value">{{ stats().cancelled }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-building"></i> Supplier</label>
        <select [ngModel]="supplierFilter()" (ngModelChange)="supplierFilter.set($event); onFilterChange()">
          <option value="all">All Suppliers</option>
          @for (supplier of suppliers(); track supplier.id) {
            <option [value]="supplier.id">{{ supplier.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-building"></i> Branch</label>
        <select [ngModel]="branchFilter()" (ngModelChange)="branchFilter.set($event); onFilterChange()">
          @if (!branchFilterLocked()) {
            <option value="all">All Branches</option>
          }
          @for (branch of branches(); track branch.id) {
            <option [value]="branch.id">{{ branch.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-geo-alt"></i> Location</label>
        <select [ngModel]="locationFilter()" (ngModelChange)="locationFilter.set($event); onFilterChange()">
          <option value="all">All Locations</option>
          @for (location of locations(); track location.id) {
            <option [value]="location.id">{{ location.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-check-circle"></i> Status</label>
        <select [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event); onFilterChange()">
          <option value="all">All Status</option>
          <option value="draft">Draft</option>
          <option value="posted">Completed</option>
          <option value="cancelled">Returned</option>
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredReceipts().length }} receipts</span>
      <button class="btn btn-outline btn-sm" type="button" (click)="clearFilters()">Clear filters</button>
    </div>
  </div>

  <div class="table-wrap">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>Receipt No.</th>
            <th>Supplier</th>
            <th>Item</th>
            <th>Branch</th>
            <th>Location</th>
            <th>Qty</th>
            <th>Total Value</th>
            <th>Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (note of paginatedReceipts(); track note.id) {
            <tr>
              <td><span class="receipt-id">{{ note.grnNumber }}</span></td>
              <td>{{ note.supplier }}</td>
              <td>{{ note.itemName || '—' }}</td>
              <td><span class="branch-tag">{{ note.branch }}</span></td>
              <td><span class="location-tag">{{ note.location }}</span></td>
              <td>{{ note.items }}</td>
              <td>{{ formatCurrency(note.totalValue) }}</td>
              <td>{{ formatDate(note.receivedDate) }}</td>
              <td>
                <span class="status-badge" [class]="note.status">
                  {{ displayStatus(note.status) }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action edit" title="Edit receipt" (click)="openEditModal(note)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button
                    type="button"
                    class="btn-action delete"
                    title="Cancel receipt"
                    [disabled]="note.status === 'cancelled'"
                    (click)="deleteReceipt(note)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="10" class="empty-cell">No receipts match your search or filters.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>{{ paginationStart() }}</span> to <span>{{ paginationEnd() }}</span> of <span>{{ filteredReceipts().length }}</span> receipts
    </div>
    <div class="pagination-controls">
      <button class="btn btn-outline btn-sm" [disabled]="page() === 1" (click)="goToPage(page() - 1)"><i class="bi bi-chevron-left"></i> Previous</button>
      @for (p of pageNumbers(); track p) {
        <button class="btn btn-sm" [class.btn-primary]="page() === p" [class.btn-outline]="page() !== p" (click)="goToPage(p)">{{ p }}</button>
      }
      <button class="btn btn-outline btn-sm" [disabled]="page() === totalPages()" (click)="goToPage(page() + 1)">Next <i class="bi bi-chevron-right"></i></button>
    </div>
  </div>
</div>

<!-- New/Edit Receipt Modal -->
<div class="modal-overlay" [class.open]="showReceiptModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large">
    <div class="modal-header">
      <h2>
        <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
        {{ isEditing() ? 'Edit Goods Received' : 'New Goods Received' }}
      </h2>
      <button class="close-btn" (click)="closeReceiptModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      @if (!dropdownsReady()) {
        <div class="form-row">
          <div class="form-group full">
            <p style="margin:0;color:#b45309;">
              Loading suppliers, branches, locations…
              For a new item you also need categories and units from Settings.
              For an existing item, open Register Items first if the catalog stays empty.
            </p>
          </div>
        </div>
      }

      <div class="form-row">
        <div class="form-group">
          <label>Supplier <span class="required">*</span></label>
          <select [ngModel]="newReceipt().supplier" (ngModelChange)="updateNewReceipt('supplier', $event)">
            <option value="">Select Supplier</option>
            @for (supplier of suppliers(); track supplier.id) {
              <option [value]="supplier.id">{{ supplier.name }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>Received Date <span class="required">*</span></label>
          <input type="date" [ngModel]="newReceipt().receivedDate" (ngModelChange)="updateNewReceipt('receivedDate', $event)" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Branch <span class="required">*</span></label>
          <select [ngModel]="newReceipt().branch" (ngModelChange)="updateNewReceipt('branch', $event)">
            <option value="">Select Branch</option>
            @for (branch of branches(); track branch.id) {
              <option [value]="branch.id">{{ branch.name }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>Store Location <span class="required">*</span></label>
          <select [ngModel]="newReceipt().location" (ngModelChange)="updateNewReceipt('location', $event)">
            <option value="">Select Location</option>
            @for (location of modalLocations(); track location.id) {
              <option [value]="location.id">{{ location.name }}</option>
            }
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group full">
          <label>Item source <span class="required">*</span></label>
          <div class="item-mode-toggle">
            <label class="item-mode-option">
              <input
                type="radio"
                name="itemMode"
                value="existing"
                [ngModel]="newReceipt().itemMode"
                (ngModelChange)="updateNewReceipt('itemMode', $event)"
              />
              Existing catalog item
            </label>
            <label class="item-mode-option">
              <input
                type="radio"
                name="itemMode"
                value="new"
                [ngModel]="newReceipt().itemMode"
                (ngModelChange)="updateNewReceipt('itemMode', $event)"
              />
              New item (not in catalog)
            </label>
          </div>
        </div>
      </div>

      @if (newReceipt().itemMode === 'existing') {
        <div class="form-row">
          <div class="form-group">
            <label>Catalog Item <span class="required">*</span></label>
            <select [ngModel]="newReceipt().itemId" (ngModelChange)="updateNewReceipt('itemId', $event)">
              <option value="">Select Item</option>
              @for (item of catalogItems(); track item.id) {
                <option [value]="item.id">{{ item.code }} — {{ item.name }}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>Quantity <span class="required">*</span></label>
            <input type="number" min="1" step="1" appDigitsOnly [ngModel]="newReceipt().quantity" (ngModelChange)="updateNewReceipt('quantity', $event)" />
          </div>
        </div>
      } @else {
        <div class="form-row">
          <div class="form-group">
            <label>New Item Name <span class="required">*</span></label>
            <input
              type="text"
              placeholder="e.g. White Gloves"
              [ngModel]="newReceipt().newItemName"
              (ngModelChange)="updateNewReceipt('newItemName', $event)"
            />
          </div>
          <div class="form-group">
            <label>Quantity <span class="required">*</span></label>
            <input type="number" min="1" step="1" appDigitsOnly [ngModel]="newReceipt().quantity" (ngModelChange)="updateNewReceipt('quantity', $event)" />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Category <span class="required">*</span></label>
            <select [ngModel]="newReceipt().categoryId" (ngModelChange)="updateNewReceipt('categoryId', $event)">
              <option value="">Select Category</option>
              @for (category of categories(); track category.id) {
                <option [value]="category.id">{{ category.name }}</option>
              }
            </select>
          </div>
          <div class="form-group">
            <label>Unit of Measure <span class="required">*</span></label>
            <select [ngModel]="newReceipt().unitId" (ngModelChange)="updateNewReceipt('unitId', $event)">
              <option value="">Select Unit</option>
              @for (unit of units(); track unit.id) {
                <option [value]="unit.id">{{ unit.name }}</option>
              }
            </select>
          </div>
        </div>
      }

      <div class="form-row">
        <div class="form-group">
          <label>Unit Cost</label>
          <input type="number" min="0" step="0.01" appDecimalOnly [ngModel]="newReceipt().unitCost" (ngModelChange)="updateNewReceipt('unitCost', $event)" />
        </div>
        <div class="form-group">
          <label>Total Value</label>
          <input type="number" min="0" step="0.01" appDecimalOnly [ngModel]="newReceipt().totalValue" (ngModelChange)="updateNewReceipt('totalValue', +$event)" />
        </div>
      </div>

      <!-- Rentable Toggle -->
      <div class="form-row">
        <div class="form-group full">
          <div class="rentable-toggle-wrapper">
            <div class="toggle-header">
              <span class="toggle-title"><i class="bi bi-key"></i> Items are Rentable</span>
              <span class="toggle-status" [class.active]="newReceipt().isRentable">
                {{ newReceipt().isRentable ? 'Yes' : 'No' }}
              </span>
            </div>
            <div class="toggle-container">
              <label class="toggle-switch large">
                <input type="checkbox" [ngModel]="newReceipt().isRentable" (ngModelChange)="updateNewReceipt('isRentable', $event)" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-description">
                Enable if received items can be rented out to customers
              </span>
            </div>
          </div>
        </div>
      </div>

      @if (isEditing()) {
        <div class="form-row">
          <div class="form-group">
            <label>Status <span class="required">*</span></label>
            <select [ngModel]="newReceipt().status" (ngModelChange)="updateNewReceipt('status', $event)">
              <option value="draft">Draft</option>
              <option value="posted">Completed</option>
              <option value="cancelled">Returned</option>
            </select>
          </div>
        </div>
      }
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeReceiptModal()">Cancel</button>
      @if (isEditing()) {
        <button class="btn btn-primary" (click)="submitReceipt()">
          <i class="bi bi-check-lg"></i> Save Changes
        </button>
      } @else {
        <button class="btn btn-outline" (click)="submitReceipt('draft')">Save as Draft</button>
        <button class="btn btn-primary" (click)="submitReceipt('posted')">
          <i class="bi bi-check-lg"></i> Submit Receipt
        </button>
      }
    </div>
  </div>
</div>

@if (showToast()) {
  <div class="toast-container show">
    <div
      class="toast"
      [class.success]="toastType() === 'success'"
      [class.error]="toastType() === 'error'"
      [class.info]="toastType() === 'info'"
    >
      <div class="toast-icon">
        @if (toastType() === 'error') {
          <i class="bi bi-x-circle-fill"></i>
        } @else if (toastType() === 'info') {
          <i class="bi bi-info-circle-fill"></i>
        } @else {
          <i class="bi bi-check-circle-fill"></i>
        }
      </div>
      <div class="toast-content">
        <div class="toast-title">
          {{ toastType() === 'error' ? 'Error' : toastType() === 'info' ? 'Notice' : 'Success!' }}
        </div>
        <div class="toast-message">{{ toastMessage() }}</div>
      </div>
    </div>
  </div>
}
